(function() {

    const app = angular
        .module('rocket', [

            // ng
            'ngRaven',
            'ngAnimate',
            'ngAria',
            'ngCookies',
            'ngMaterial',
            'ngMessages',
            'ngResource',
            'ngSanitize',

            // 3rd party
            'ui.router',
            'ui.router.state.events',
            'pascalprecht.translate',
            // 'angular-loading-bar',
            'fuse.msNavigation',
            'formly',
            'formlyMaterial',
            'environment',
            'md.data.table',
            'angularMoment',
            'ngFileUpload',
            'dndLists',
            'ngScrollbars',
            'LocalStorageModule',

            // generated
            'rocket.api',
            'rocket.templates',
            'rocket.locales',

            // components
            'rocket.components',

        ]);

    app.config(function(ScrollBarsProvider) {
        ScrollBarsProvider.defaults = {
            advanced: {
                updateOnContentResize: true,
            },
            autoHideScrollbar: false,
            axis: 'x',
            scrollButtons: {
                scrollAmount: '50px',
                enable: true,
            },
            scrollInertia: 100,
            theme: 'dark-thin',
        };
    });
})();
